import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/landingPage/footer.scss";

import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

import LogoPng from "../../../assets/header/logo-white.png";
import DBDPng from "../../../assets/home/footer/dbd.png";
import { ReactComponent as FacebookSvg } from "../../../assets/home/footer/facebook.svg";
import { ReactComponent as TwitterSvg } from "../../../assets/home/footer/twitter.svg";
import { ReactComponent as InstagramSvg } from "../../../assets/home/footer/instagram.svg";
import { ReactComponent as MailSvg } from "../../../assets/home/footer/mail.svg";
import { ReactComponent as TelSvg } from "../../../assets/home/footer/tel.svg";
import { ReactComponent as ToggleArrow } from "../../../assets/home/footer/toggle-arrow.svg";
import Menu from "../../common/Header/Menu";
import { languageMenus, profileMenus } from "../../../constants";

const Footer = (props) => {
  const [toggledWebsite, setToggledWebsite] = useState(false);
  const [toggledUpload, setToggledUpload] = useState(false);
  const [toggledTerms, setToggledTerms] = useState(false);
  const navigate = useNavigate();
  const { isAuth, toggleAuthModal, getLang, setLang, lang } =
    useContext(AppContext);
  const Translation = getLang(langComponent.footer);
  const [isToggleLanguage, setIsToggleLanguage] = useState(false);

  const handleNavigate = (to) => {
    navigate(to);
  };

  const handleShareProjectClick = () => {
    if (isAuth) {
      navigate("/new-project");
      return;
    }

    if (!isAuth) {
      toggleAuthModal(true, "signup", "/new-project");
      return;
    }
  };

  const getDisplayLangName = () => {
    return languageMenus.find((f) => f.value === lang).name;
  };

  const getDisplayLangIcon = () => {
    return languageMenus.find((f) => f.value === lang).icon;
  };

  const handleSelectLang = (data) => {
    setIsToggleLanguage(false);
    setLang(data.value);
  };

  const handleLanguageToggleClick = () => {
    setIsToggleLanguage((curr) => !curr);
  };

  return (
    <div className="lp-footer">
      <div className="seo">
        <h1 className="">Urbaan Communities</h1>
        <h2 className="">Designers</h2>
        <h2 className="">Property Developers</h2>
        <h2 className="">Platform for designers and property developers</h2>
      </div>
      <div className="lp-footer-content">
        <div className="lp-footer-content-left">
          <img
            className="lp-footer-content__logo"
            alt="logo"
            src={LogoPng}
            height={64}
          />
          <span>{Translation("address")}</span>
          <span>
            {Translation("openTime")} {Translation("Everyday")}
          </span>
          <h5 style={{ fontWeight: 500, fontSize: 14, margin: 0 }}>
            {Translation("Contact us")}
          </h5>
          <div className="lp-footer-content-contacts">
            <div className="lp-footer-content-contacts-section">
              <FacebookSvg className="lp-footer-content-contacts__link" />
              <InstagramSvg className="lp-footer-content-contacts__link" />
              <TwitterSvg className="lp-footer-content-contacts__link" />
            </div>
            <div className="lp-footer-content-contacts-section">
              <MailSvg className="lp-footer-content-contacts__link" />
              <span className="lp-footer-content-contacts__link">
                {Translation("email")}
              </span>
            </div>
            <div className="lp-footer-content-contacts-section">
              <TelSvg />
              <a
                href="tel:+66829989892"
                className="lp-footer-content-contacts__tel"
              >
                082-998-9892
              </a>
            </div>
          </div>
        </div>
        <div className="lp-footer-content-right">
          <div className="lp-footer-content-links-desktop">
            <div className="lp-footer-content-links-desktop-section lp-footer-websites">
              <h4 className="lp-footer-content-links-desktop__header">
                {Translation("Our website")}
              </h4>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => handleNavigate("/")}
              >
                {Translation("Home")}
              </h5>
              <h5 className="lp-footer-content-links-desktop__link">
                {Translation("About us")}
              </h5>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => handleNavigate("/art-designs/community-spaces")}
              >
                {Translation("Community Space")}
              </h5>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => handleNavigate("/art-designs/work-exchanges")}
              >
                {Translation("Work Exchanges")}
              </h5>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => handleNavigate("/tenderings")}
              >
                {Translation("Tenderings")}
              </h5>
            </div>
            <div className="lp-footer-content-links-desktop-section lp-footer-websites">
              <h4 className="lp-footer-content-links-desktop__header">
                {Translation("Upload")}
              </h4>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={handleShareProjectClick}
              >
                {Translation("Work & Designs")}
              </h5>
            </div>
            <div className="lp-footer-content-links-desktop-section lp-footer-websites">
              <h4 className="lp-footer-content-links-desktop__header">
                {Translation("Terms")}
              </h4>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => {
                  navigate("/support/terms-and-conditions");
                }}
              >
                {Translation("Terms & Conditions")}
              </h5>
              <h5
                className="lp-footer-content-links-desktop__link"
                onClick={() => handleNavigate("/support/privacy")}
              >
                {Translation("Privacy Policy")}
              </h5>
            </div>
          </div>
          <div className="lp-footer-content-links-mobile">
            <div className="lp-footer-content-links-mobile lp-footer-websites">
              <div
                className="lp-footer-content-links-mobile__header"
                onClick={() => setToggledWebsite(!toggledWebsite)}
              >
                <h4>{Translation("Our website")}</h4>
                <ToggleArrow
                  className={`lp-footer-content-links-mobile__header-arrow ${
                    toggledWebsite
                      ? "lp-footer-content-links-mobile__header-arrow--toggle"
                      : ""
                  }`}
                />
              </div>
              {toggledWebsite && (
                <>
                  <h5 className="lp-footer-content-links-mobile__link">
                    {Translation("Home")}
                  </h5>
                  <h5 className="lp-footer-content-links-mobile__link">
                    {Translation("About us")}
                  </h5>
                  <h5 className="lp-footer-content-links-mobile__link">
                    {Translation("360 Panoramas")}
                  </h5>
                </>
              )}
            </div>
            <div className="lp-footer-content-links-mobile lp-footer-websites">
              <div
                className="lp-footer-content-links-mobile__header"
                onClick={() => setToggledUpload(!toggledUpload)}
              >
                <h4>{Translation("Upload")}</h4>
                <ToggleArrow
                  className={`lp-footer-content-links-mobile__header-arrow ${
                    toggledUpload
                      ? "lp-footer-content-links-mobile__header-arrow--toggle"
                      : ""
                  }`}
                />
              </div>
              {toggledUpload && (
                <>
                  <h5 className="lp-footer-content-links-mobile__link">
                    {Translation("Work & Designs")}
                  </h5>
                </>
              )}
            </div>
            <div className="lp-footer-content-links-mobile lp-footer-websites">
              <div
                className="lp-footer-content-links-mobile__header"
                onClick={() => setToggledTerms(!toggledTerms)}
              >
                <h4>{Translation("Terms")}</h4>
                <ToggleArrow
                  className={`lp-footer-content-links-mobile__header-arrow ${
                    toggledTerms
                      ? "lp-footer-content-links-mobile__header-arrow--toggle"
                      : ""
                  }`}
                />
              </div>
              {toggledTerms && (
                <>
                  <h5
                    className="lp-footer-content-links-mobile__link"
                    onClick={() => {
                      navigate("/support/terms-and-conditions");
                    }}
                  >
                    {Translation("Terms & Conditions")}
                  </h5>
                  <h5 className="lp-footer-content-links-mobile__link">
                    {Translation("Privacy Policy")}
                  </h5>
                </>
              )}
            </div>
          </div>
          <div className="lp-footer-content-right-dbd">
            <img alt="dbd" src={DBDPng} />
          </div>
        </div>
      </div>
      <div className="lp-footer-misc">
        <div>© All right reserved, Insight Scape Co., Ltd.</div>
        <div className="lp-footer-misc-language">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
            }}
            onClick={handleLanguageToggleClick}
          >
            {getDisplayLangIcon()}
            <label className="lp-footer-misc-language__label">
              {getDisplayLangName()}
            </label>
          </div>
          {isToggleLanguage && (
            <Menu
              menus={languageMenus}
              onSelectMenu={handleSelectLang}
              style={{ bottom: "64px", top: "auto", borderRadius: "8px" }}
              onClose={() => {
                console.log("closing");

                setIsToggleLanguage(false);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {};

export default Footer;
